import styled from 'styled-components';
import { DESKTOP } from '../../../styles/breakpoints';
import { ViewDesktop } from '../../../styles/themes/responsive.styled';
import { HomeContainer } from '../../../components/home-components/home-page.styled';

export const SelectedCandidatesContainer = styled(HomeContainer)``;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media(min-width: ${DESKTOP}) {
        max-width: 1156px;
        margin: 0 auto;
    }
`;

export const DashboardHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const NotificationRow = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: .5rem;
`;

export const StatisticsRow = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: .5rem;
`;

export const ViewDesktopFilters = styled(ViewDesktop)`
    margin-bottom: 2.5rem;
`;

export const CandidatesNotFound = styled.span`
    color: #858B8D;
    margin-top: 1rem;
    .icon-search {
        vertical-align: text-bottom;
        margin-right: .5rem;
        font-size: 1.5rem;
    }
`;

export const CommentButton = styled.button`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    border: none;
    margin: 0;
    padding: 0;
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    background: none;
`;